import { useEffect, useState } from "react";
import { createDefaultScheduledDate } from "./helpers";
import { DateOption } from "./types";

export const useVisualActionSelection = () => {
  const [selectedAction, setSelectedAction] = useState<string | null>(null);
  const [dateOption, setDateOption] = useState<DateOption>("tomorrow");
  const [description, setDescription] = useState<string | null>(null);
  const [customDate, setCustomDate] = useState<string | null>(
    createDefaultScheduledDate()
  );

  // Endast actionbyte resettar tiden — inte togglebyte, det sköts i
  // handleDateOptionChange. Annars skulle ett chip-val ("ledig tid") som
  // sätter dateOption till "custom" skrivas över av denna effekt.
  useEffect(() => {
    setCustomDate(createDefaultScheduledDate(selectedAction));
  }, [selectedAction]);

  const handleActionClick = (actionType: string) => {
    console.log("Action clicked:", actionType);
    setSelectedAction(actionType);
  };

  const handleDateOptionChange = (
    event: React.MouseEvent<HTMLElement>,
    newOption: DateOption | null
  ) => {
    if (newOption !== null) {
      setDateOption(newOption);
      setCustomDate(createDefaultScheduledDate(selectedAction));
    }
  };

  const handleCustomDateChange = (date: string | null) => {
    setCustomDate(date);
  };

  // Klick på en "ledig tid"-chip: hoppa till anpassat datum med exakt tid
  const handleSlotSelect = (isoLocalDate: string) => {
    setDateOption("custom");
    setCustomDate(isoLocalDate);
  };

  const resetSelections = () => {
    setSelectedAction(null);
    setDateOption("tomorrow");
    setCustomDate(createDefaultScheduledDate());
  };
  return {
    selectedAction,
    dateOption,
    customDate,
    description,
    setDescription,
    handleActionClick,
    handleDateOptionChange,
    handleCustomDateChange,
    handleSlotSelect,
    resetSelections,
  };
};
